import Table from "@/components/Table/table";
import {
  useDeleteClaimItemCategoryMutation,
  useGetconfigCategoryApiDataQuery,
} from "@/services/claimSummary/caseSummaryReducer";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import { useEffect, useMemo, useState } from "react";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import {
  MotifButton,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from "@ey-xd/motif-react";
import { useNavigate, Link } from "react-router-dom";
import { useCase } from "@/features/case/use-case";
import {
  customPaginationPageSize,
  customPaginationPageSizeSelector,
  customTableLoadingData,
} from "@/components/Table/CustomPaginationConstants";
import CustomPagination from "@/components/Pagination/CustomPagination";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { havingAddPermission, havingEditPermission } from "@/utility/common";
import {
  CREATE_BUTTON_VARIANT,
  DELETE_BUTTON_VARIANT,
  GetCommonDeleteImgButton,
} from "@/components/Images/CommonImages";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
export const CategoryGrid = () => {
  const caseData = useCase();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const paginationPageSize: number = customPaginationPageSize;
  const paginationPageSizeSelector: number[] = customPaginationPageSizeSelector;
  let tableLoadingData = customTableLoadingData;
  const retainState = useSelector(
    (e: any) => e.retainState.categoryListTabState
  );
  const dispatch = useDispatch();
  const getPaginationObj: any = useMemo(() => {
    let value: any = {
      CaseId: caseData?.caseId,
      PageNumber: retainState?.PageNumber || 1,
      PageSize: retainState?.PageSize || paginationPageSize,
      SearchText: retainState?.SearchText || "",
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  }, [caseData?.caseId, paginationPageSize, retainState]);
  const paginationObj = getPaginationObj;
  const permissions = useSelector((state: any) => state.permissions);
  const { ClaimItemCategory } = permissions;

  function handlePaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "categoryListTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }

  const { data, isLoading, isFetching, error, refetch, status } =
    useGetconfigCategoryApiDataQuery(paginationObj);
  const [notifcation, setNotifcation] = useState<any>({});
  const [showModal, setShowModal] = useState<any>(null);
  const [deleteClaimItemCategory, { isLoading: deleteLoading }] =
    useDeleteClaimItemCategoryMutation();
  const [currentId, setCurrentId] = useState();
  const [entityName, setEntityName] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  async function deleteCategory() {
    const response = await deleteClaimItemCategory(currentId);
    setShowModal(false);
    if ("data" in response) {
      if (response?.data?.isSuccess)
        setNotifcation({
          message: t("pages.configuration.category.deleteSuccessfully"),
          type: "success",
        });
      else setNotifcation({ message: response?.data?.message, type: "error" });
      refetch();
    } else {
      setNotifcation({
        message: t("global.globalNotifications.wentWrong"),
        type: "error",
      });
    }
  }

  const caseRenderers = {
    actionCellRenderer: function (params: any) {
      return (
        <>
          {havingEditPermission(ClaimItemCategory) && (
            <GetCommonDeleteImgButton
              onClick={() => {
                setNotifcation({});
                setShowModal(true);
                setCurrentId(params?.data?.id);
                setEntityName(params?.data?.name);
              }}
            ></GetCommonDeleteImgButton>
            // <div className="pad-r-10">
            //   <CommonTooltipWrapper
            //     tooltipTitle={t("global.globalActions.delete")}
            //   >
            //     <MotifButton
            //       size="small"
            //       variant={DELETE_IMG_VARIANT}
            //       onClick={() => {
            //         setNotifcation({});
            //         setShowModal(true);
            //         setCurrentId(params?.data?.id);
            //         setEntityName(params?.data?.name);
            //       }}
            //     >
            //       {getCommonDeleteImg()}
            //     </MotifButton>
            //   </CommonTooltipWrapper>
            // </div>
          )}
          {/* <MotifButton
            size="small"
            type="submit"
            variant="primary"
            onClick={() =>
              navigate(
                `/case/${caseData?.caseId}/edit-category/${params.data.id}`
              )
            }
          >
            <MotifIcon
              iconFunction={IconoirEditPencil}
              stroke="blue"
              strokeWidth="2"
              size="24"
            />
          </MotifButton> */}
        </>
      );
    },
  };
  const columnDefs = [
    {
      cellRenderer: (params: any) => {
        return havingEditPermission(ClaimItemCategory) ? (
          <Link to={`./edit-category/${params?.data?.id}`}>
            <span className="text-bold-underline">{params?.data?.name}</span>
          </Link>
        ) : (
          <>{params?.data?.name}</>
        );
      },
      comparator: () => 0,
      field: "name",
      type: "categoryNameType",
      headerName: t("pages.configuration.category.columnDetails.column1"),
      sortable: true,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      autoHeight: true,
      flex: 1,
      minWidth:150
    },
    {
      comparator: () => 0,
      field: "description",
      type: "descriptionType",
      headerName: t("pages.configuration.category.columnDetails.column2"),
      sortable: true,
      unSortIcon: true,
      flex: 1,
      wrapText: true,
      autoHeight: true,
      cellClass: "overFlowWrapAnywhere",
      minWidth:200

    },
    {
      cellRenderer: "actionCellRenderer",
      field: "action",
      headerName: "",
      sortable: false,
      unSortIcon: true,
      cellStyle: {
        "justify-content": "right",
        minWidth:60

      },
    },
  ];
  function TitleComplement(ClaimItemCategoryPermissions: string[]) {
    return havingAddPermission(ClaimItemCategoryPermissions) ? (
      <MotifButton
        variant={CREATE_BUTTON_VARIANT}
        onClick={() => navigate(`/case/${caseData?.caseId}/create-category`)}
      >
        {t("pages.configuration.category.createCategory")}
      </MotifButton>
    ) : (
      <></>
    );
  }
  const categoryData = data?.results ? data.results : [];
  return (
    <>
      <MotifModal
        onClose={() => setShowModal(false)}
        show={showModal}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>

          <MotifModalBody style={{ paddingTop: "0px" }}>
            <span style={{ fontWeight: "300" }}>
              {useTrans(
                t,
                t("pages.configuration.category.deleteCategoryMessage", {
                  categoryName: entityName,
                }),
                "categoryName"
              )}
            </span>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              size="small"
              type={deleteLoading ? "loader" : "submit"}
              variant={DELETE_BUTTON_VARIANT}
              style={{
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
              onClick={deleteCategory}
            >
              {t("pages.configuration.attributes.deleteButton")}
            </MotifButton>
          </MotifModalFooter>
        </div>
      </MotifModal>
      {notifcation.hasOwnProperty("type") && (
        <NotificationGrid
          show={true}
          message={notifcation?.message}
          type={notifcation?.type}
        />
      )}
      <br />
      {isLoading ? (
        <MotifProgressLoader show variant="default" />
      ) : (
        <div>
          <Table
            columnDefs={columnDefs}
            columnTypes={{ ...retainState.sortedColumnTypes }}
            handlePaginationData={handlePaginationData}
            paginationObj={paginationObj}
            cellRenderers={isFetching ? [] : categoryData}
            TitleComplement={() => TitleComplement(ClaimItemCategory)}
            title={"pages.configuration.category.title"}
            description="pages.configuration.category.tableDescription"
            pagination={false}
            caseRenderers={caseRenderers}
            overlayNoRowsTemplate={
              isFetching
                ? t(tableLoadingData)
                : error
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
          <CustomPagination
            apiData={data}
            apiStatus={status}
            currentpage={paginationObj.PageNumber}
            pageSize={paginationObj.PageSize}
            disableNext={!data?.hasMoreRecords}
            onChangePageSize={(page: number) => {
              dispatch(
                setComponentState1({
                  entityName: "categoryListTabState",
                  entityState: {
                    PageSize: page,
                    PageNumber: 1,
                  },
                })
              );
            }}
            onChangeNextPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "categoryListTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber + 1,
                  },
                })
              );
            }}
            onChangePreviousPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "categoryListTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber - 1,
                  },
                })
              );
            }}
            pageSizeSelector={paginationPageSizeSelector}
          />
        </div>
      )}
    </>
  );
};
